import * as React from "react"
import { X } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import {cn} from "@/lib/utils.ts";
import {Checkbox} from "@/components/ui/checkbox.tsx";

export type Option = {
  label: string
  value: string
}

interface MultiSelectProps {
  options: Option[]
  selected: Option[]
  onChange: (options: Option[]) => void
  placeholder?: string
  popoverClassName?: string
  onOpenChange?: (open: boolean) => void
}

export function MultiSelect({
  options,
  selected,
  onChange,
  placeholder = "בחר...",
  ...props
}: MultiSelectProps) {
  const [open, setOpen] = React.useState(false)

  const handleUnselect = (option: Option) => {
    onChange(selected.filter((item) => item.value !== option.value))
  }

  return (
    <Popover open={open} onOpenChange={setOpen} {...props}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between h-10">
          {selected.length > 0 ? `${selected.length} נבחרו` : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent sideOffset={-40} className={cn("w-full p-0", props.popoverClassName)}>
        <Command>
          <CommandInput placeholder="חפש..." />
          <CommandList>
            <CommandEmpty>לא נמצאו סוגי שלוחות תואמים לחיפוש שלך</CommandEmpty>
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.value}
                  onSelect={() => {
                    onChange(
                      selected.some((item) => item.value === option.value)
                        ? selected.filter((item) => item.value !== option.value)
                        : [...selected, option],
                    )
                    setOpen(true)
                  }}
                >
                  <Checkbox
                      className="border-gray-400"
                      checked={selected.some((item) => item.value === option.value)}
                  />
                  {option.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
      {/*<div className="flex flex-wrap gap-1 mt-2">*/}
      {/*  {selected.map((option) => (*/}
      {/*    <Button*/}
      {/*      key={option.value}*/}
      {/*      variant="secondary"*/}
      {/*      size="sm"*/}
      {/*      className="h-7 rounded-full"*/}
      {/*      onClick={() => handleUnselect(option)}*/}
      {/*    >*/}
      {/*      {option.label}*/}
      {/*      <X className="w-3 h-3 ml-1" />*/}
      {/*    </Button>*/}
      {/*  ))}*/}
      {/*</div>*/}
    </Popover>
  )
}

